import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { allValidations } from "../../utils/formValidations";
import { HOST } from "../../constants";
import { fetchOrderDetails, updateOrderStatus } from "../../redux/actions/orderAction";

export default function OrderContainer() {
    let { orderDetails } = useSelector((state) => state.order);

    const dispatch = useDispatch();
    const history = useHistory();

    const { id } = useParams();

    const [data, setData] = useState({});

    useEffect(() => {
        if (id) {
            dispatch(
                fetchOrderDetails(id, (res) => {
                    setData({ ...res });
                })
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, dispatch]);

    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);

    const handleChange = ({ name, value, formArrayName, index }) => {
        const ignoreFields = [];

        let formErrors = {};
        if (formArrayName) {
            const _newData = { ...data };
            let obj = _newData[formArrayName][index];
            obj[name] = value;
            const formErrors = allValidations(name, value, obj, ignoreFields);
            obj.formErrors = formErrors;
            _newData[formArrayName][index] = obj;
            setData(() => ({
                ..._newData,
            }));
        } else {
            formErrors = allValidations(name, value, data, ignoreFields);
            setData((prev) => ({ ...prev, [name]: value, formErrors }));
        }
    };

    const onSubmit = () => {
        dispatch(updateOrderStatus(data._id, data, history));
    };

    return {
        dispatch,
        id,
        data,
        setData,
        handleChange,
        loading,
        onSubmit,
        history,
        HOST,
        setVisible,
        setLoading,
        orderDetails,
    };
}
